import React from "react"
import {Li} from "./component"

export type StandardRecentSearchLiProps = {
    children?: React.ReactNode
    handleClick?: () => void
}

const ClubRecentSearchLi = ({children, handleClick}: StandardRecentSearchLiProps) => (
    <Li onClick={handleClick}>{children}</Li>
)

export default ClubRecentSearchLi
